import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DailyLegLoadService } from '../../../services/daily-leg-loads/daily-leg-load.service';
import { DailyLegLoadExtensionModel } from '../../../models/daily-leg-loads/daily-leg-load.models';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-daily-leg-load-total-extensions',
  templateUrl: 'daily-leg-load-total-extensions.html',
})
export class DailyLegLoadTotalExtensionsPage {
  config = AppConfig.settings;

  dailyLogDate: PtLuxonDate;
  legExtensionModel: DailyLegLoadExtensionModel;
  loading: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private dailyLegLoadService: DailyLegLoadService,
  ) {
    this.dailyLogDate = this.navParams.get('date');
  }

  ionViewDidLoad() {
    this.updateLegExtensionData();
  }

  updateLegExtensionData() {
    this.loading = true;

    this.dailyLegLoadService.getTotalLegExtensionData({
      date: this.dailyLogDate.dateTime
    }).then(result => {
      this.legExtensionModel = result;
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-total-extensions/daily-leg-load-total-extensions.ts